import { Autocomplete } from "@mui/material";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons/faChevronDown";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons/faChevronUp";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { faSquareCheck } from "@fortawesome/free-solid-svg-icons/faSquareCheck";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { InputData } from "app/components/inputs/InputData";
import Legenda from "app/components/itens-orcamento/legenda/Legenda";
import { Paginacao } from "app/components/itens-orcamento/paginacao/Paginacao";
import { IFilial } from "app/types/IFilial";
import { ProdutoFiltrado } from "app/types/IProduto";
import { ISituacao, TiposOrcamento } from "app/types/pesquisa-orcamento/PesquisaOrcamento";
import { Vendedor } from "app/types/Vendedor";
import clsx from "clsx";
import { FormikErrors, useFormik } from "formik";
import globalMU from "globalMU";
import R from "ramda";
import React, { useEffect, useState, useCallback, useMemo, useRef } from "react"
import { TextField } from "@mui/material";
import { SolicitarSenhaContainer } from "app/components/senha/SolicitarSenhaContainer";

const estilosInputs = require('../../../estilos/inputs.module.scss').default
const estilosBotoes = require("../../../estilos/botoes.module.scss").default
const estiloTabela = require('../../../estilos/tabelas.module.scss').default
const estiloFormulario = require('../../../estilos/formulario.module.scss').default
const estiloCotacoesPerdidas = require("../../cotacoes-perdidas/cotacoes-perdidas.module.scss").default

export interface DadosOrdemDeProducao {
    Index: number // 440721
    FilialPedido: string // 440721
    NumeroPedido: number
    SituacaoPedido: string // 440721
    DataPedido: string
    CodigoCliente: number
    NomeCliente: string
    CodigoItem: number
    CodigoProduto: string
    CodigoProdutoMostrar: string // 440721
    DescricaoProduto: string
    // 440721 DescricaoCompletaProduto: string
    CodigoOrdemProducao: number
    CodigoFilialOP: string
    CodigoFilialItem: string
    ItemCodigoFilialRetirada: string
    QuantidadeItem: number
    DataPrevistaEntregaItem: string
    DataPrevistaEntregaPedido: string
    PrazoEntregaProduto: number
    SituacaoOrdemProducao: number
    CodigoVendedor: string
    NomeVendedor: string
    Vendedor: string // 440721
    EstoqueReservado: string // 440721
    ExiteInsumoSemEstoque: number // 472375
    //SituacaoManutencao: string
    DataMarcada: string
    MensagemErro: string
    CorLegenda: string
    ProdutoComponente: number // 440721
    CodigoProdutoPai: string // 440721
    CodigoProdutoPaiMostrar: string // 440721
    Nivel: number
    TotalProdutosFilhos: number // 440721
    IndexProdutoPai: number // 440721
    //UserMessage: any
    //Transforming: boolean
}

export interface ConsultaOrdemDeProducaoFiltro {
    NumeroPedido: number
    DataInicial: string
    DataFinal: string
    //CodigoFilial: string
    //ObrigarFiltrarFilial: boolean
    CodigoVendedor: string
    //ObrigarFiltrarVendedor: boolean
    EstoqueReservado: string
    ListaProdutosSelecionados: string[]
    ListaSituacoesPedido: string[]
    ListaFiliaisSelecionadas: string[]
    ListaVendedoresSelecionados: string[]
    //
    ColunaOrdenacao: string
    OrdemOrdenacaoDecrescente: boolean
    //
    NumeroPagina: number

    //dados para filtro
    Filiais?: IFilial[]
    Situacoes?: ISituacao[]
    Vendedores?: Vendedor[]
    ListaTiposOrcamento?: TiposOrcamento[]
    CodigoFilialDefaultUsuario?: string
    VendedorLogado?: Vendedor
    //
}

export type ConsultaOrdemDeProducaoProps = {
    filtro?: ConsultaOrdemDeProducaoFiltro
    produtosFiltrados?: ProdutoFiltrado[]
    processando?: boolean
    pedirSenhaLiberacao?: boolean // 471071
    listaOrdemProducao: Partial<PagedMessageResponse<DadosOrdemDeProducao>>
    ordemProducaoSelecionadoLista: Partial<DadosOrdemDeProducao>[]
    cancelamentoMultiplo: boolean
    onPesquisar: (numeroPagina: number, filtro: ConsultaOrdemDeProducaoFiltro, clickBotaoPesquisar: boolean) => void
    onSenhaValidada: (senhaValida: boolean, senha?: string) => void
    onPesquisarProduto: () => void
    onEditarOrdemDeProducao: () => void
    onRemoverProdutoSelecionado: (produto: ProdutoFiltrado) => void
    onGerarOrdemDeProducao: (senhaLiberacao: string | null) => void
    onSelecionarTodos: () => void
    onCancelarOrdemDeProducao: () => void // 471071
    onConfirmarCancelamentoMultiplo: () => void // 472375
    onNumeroPedidoAlterado: (numeroPedido: number) => void
    //onAlterarListaSelecionada: (filtro: ConsultaOrdemDeProducaoFiltro) => void
    toggleOrdemProducaoSelecionado: (ordemProducao: DadosOrdemDeProducao) => void
    onErrorValidacao?: (erros: FormikErrors<ConsultaOrdemDeProducaoFiltro>) => void

    onAlterarOrdenacaoDados?: (coluna: string, decrescente: boolean, filtro: ConsultaOrdemDeProducaoFiltro) => void;
    colunaOrdenacao?: string
    ordemOrdenacaoDecrescente: boolean
}

export const ConsultaOrdemDeProducao = (props: ConsultaOrdemDeProducaoProps) => {
    const [formularioValidado, setFormularioValidado] = useState<boolean>(false)
    const [inputValueVendedor, setInputValueVendedor] = useState<string>("")
    const [listaVendedoresFiltrados, setListaVendedoresFiltrados] = useState<Vendedor[]>([])
    const [inputValueFilial, setInputValueFilial] = useState<string>("")
    const [listaFiliaisFiltradas, setListaFiliaisFiltradas] = useState<IFilial[]>([])
    const senhaLiberacaoRef = useRef(null)
    const botaoConfirmacaoCancelarMultiploRef = useRef(null)
    const posicaoParaScrollTabelaRef = useRef(null)

    const formik = useFormik({
        initialValues: {
            ...props.filtro,
            DataFinal: props.filtro?.DataFinal ?? globalMU.converterObjetoDateParaDataFormatoEN(new Date()),
        },
        onSubmit: async (values) => {

            const erros = await formik.validateForm(values)

            if (Object.keys(erros).length > 0) {
                globalMU.showErrorMessage(erros)
                return false
            }

            if (values.DataInicial != null && values.DataFinal != null
                && new Date(values.DataInicial) > new Date(values.DataFinal)) {
                globalMU.showErrorMessage("Data inicial não pode ser maior que a data final")
                return false
            }

            const produtosSelecionados = props.produtosFiltrados?.map((produto) => produto.Codigo)

            var filtro = { ...values, ListaProdutosSelecionados: produtosSelecionados }
            props.onPesquisar(1, filtro, true)
            setFormularioValidado(true);
        },
        validateOnBlur: true,
        validateOnChange: true,
        enableReinitialize: true,
    })

    const botaoSelecionarTodos = useMemo(() => (
        props.listaOrdemProducao?.Entities?.length > 0 && (
            <button
                className={`${estilosBotoes.botaoIcone} no-global-button`}
                onClick={() => props.onSelecionarTodos()}
                id="ConsultaOrdemProducao_botaoSelecionarTodos"
                title="Seleciona todas as Ordens de Produção (da página atual)"
                disabled={props.processando}
            >
                <FontAwesomeIcon icon={faSquareCheck} />
                Selecionar todos
            </button>
        )
    ), [props.listaOrdemProducao, props.ordemProducaoSelecionadoLista, props.processando, props.onSelecionarTodos])

    const botaoOrdemProducao = useMemo(() => (
        props.listaOrdemProducao?.Entities?.length > 0 && (
            <button
                className={`_flex _mr-2 no-global-button ${estilosBotoes.botaoPrimario}`}
                onClick={() => props.onGerarOrdemDeProducao(null)} // 472375
                id="ConsultaOrdemDeProducao_BotaoGerarOrdemDeProducao"
                title="Gerar Ordem de Produção dos produtos selecionados"
                disabled={props.ordemProducaoSelecionadoLista == null || props.ordemProducaoSelecionadoLista.length <= 0 || props.processando}
            >
                Gerar Ordem de Produção
            </button>
        )
    ), [props.listaOrdemProducao, props.ordemProducaoSelecionadoLista, props.processando, props.onGerarOrdemDeProducao])

    const botaoEditarOrdemProducao = useMemo(() => (
        props.listaOrdemProducao?.Entities?.length > 0 && (
            <button
                className={`_flex _mr-2 no-global-button ${estilosBotoes.botaoPrimario}`}
                onClick={props.onEditarOrdemDeProducao}
                id="ConsultaOrdemDeProducao_BotaoEditarOrdemDeProducao"
                title="Editar Ordem de Produção (produto a produto)"
                disabled={props.ordemProducaoSelecionadoLista == null || props.ordemProducaoSelecionadoLista.length !== 1 || props.processando}
            >
                Editar
            </button>
        )
    ), [props.listaOrdemProducao, props.ordemProducaoSelecionadoLista, props.processando, props.onEditarOrdemDeProducao])

    const botaoCancelarOrdemProducao = useMemo(() => (
        props.listaOrdemProducao?.Entities?.length > 0 && (
            <button
                className={`_flex _mr-2 no-global-button ${estilosBotoes.botaoPrimario}`}
                onClick={props.onCancelarOrdemDeProducao}
                id="ConsultaOrdemDeProducao_BotaoCancelarOrdemDeProducao"
                title="Cancelar Geração da Ordem de Produção"
                disabled={props.processando || props.ordemProducaoSelecionadoLista == null
                    || props.ordemProducaoSelecionadoLista.length <= 0
                    || props.ordemProducaoSelecionadoLista.filter(op => op.CodigoOrdemProducao > 0)?.length > 0}
            >
                Cancelar Geração da OP
            </button>
        )
    ), [props.listaOrdemProducao, props.ordemProducaoSelecionadoLista, props.processando, props.onCancelarOrdemDeProducao])

    const inputFiltroProdutos = useMemo(() => (
        <div className="_flex _mb-1">
            <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">
                Produtos
            </label>
            <FontAwesomeIcon
                className="_text-2xl _mx-1"
                color={"#3c8ac9"}
                id="ConsultaOrdemDeProducao_BotaoPesquisarProduto"
                icon={faSearch}
                cursor="pointer"
                onClick={props.onPesquisarProduto}
            />
        </div>
    ), [props.onPesquisarProduto])

    const produtosFiltradosTable = useMemo(() => {
        if (!props.produtosFiltrados?.length) return null;

        const tableHead = (
            <div className="_table-header-group">
                <div className="_table-row">
                    <div className={`_table-cell _font-bold ${estiloCotacoesPerdidas.tableCellHeader}`}>
                        {"Produto"}
                    </div>
                    <div
                        id="CotacoesPerdidas_campoDescricao"
                        className={`_table-cell _font-bold _w-10/12 ${estiloCotacoesPerdidas.tableCellHeader}`}>
                        Descrição
                    </div>
                    <div
                        id="CotacoesPerdidas_campoExcluir"
                        className={`_table-cell _font-bold _text-center ${estiloCotacoesPerdidas.tableCellHeader}`}>
                        Excluir
                    </div>
                </div>
            </div>
        )

        const tableRow = (
            <div className="_table-row-group">
                {props.produtosFiltrados.map((produto, index) => (
                    <div key={index}
                        className={`_table-row ${estiloCotacoesPerdidas.linha}`}
                    >
                        <div className={`_table-cell ${estiloCotacoesPerdidas.tableCellBody}`}>
                            {produto.CodigoProduto}
                        </div>
                        <div className={`_table-cell ${estiloCotacoesPerdidas.tableCellBody}`}>
                            {produto.Descricao}
                        </div>
                        <div className={`_table-cell _text-center ${estiloCotacoesPerdidas.tableCellBody}`}>
                            <FontAwesomeIcon
                                className="_text-2xl"
                                icon={faTimesCircle}
                                color={"#f25713"}
                                cursor="pointer"
                                onClick={() => props.onRemoverProdutoSelecionado(produto)}
                            />
                        </div>
                    </div>
                ))}
            </div>
        )

        return (
            <div className={`_table _w-full _border- _mb-8 ${estiloCotacoesPerdidas.tabelaCotacoesPerdidas}`}>
                {tableHead}
                {tableRow}
            </div>
        )
    }, [props.produtosFiltrados, props.onRemoverProdutoSelecionado])

    const comboBoxEstoqueReservado = useMemo(() => (
        <>
            <label
                htmlFor="ConsultaOrdemDeProducao_ComboBoxEstoqueReservado"
                className="_text-right _w-[160px] _font-normal _mb-0 _mr-3"
            >
                Estoque Reservado
            </label>
            <select
                id="ConsultaOrdemDeProducao_ComboBoxEstoqueReservado"
                className={clsx(estilosInputs.select, "_h-auto")}
                disabled={props.processando}
                onChange={(e) => formik.setFieldValue("EstoqueReservado", e.target.value)}
                ref={posicaoParaScrollTabelaRef}
            >
                <option value="A">Ambos</option>
                <option value="S">Somente Reservados</option>
                <option value="N">Somente Não Reservados</option>
            </select>
        </>
    ), [props.processando])

    const listBoxSituacoes = useMemo(() => (
        <>
            <label
                htmlFor="ConsultaOrdemDeProducao_ListaSituacoesPedido"
                className="_text-right _w-[160px] _font-normal _mb-0 _mr-3"
                title="Use as teclas SHIFT ou CTRL para selecionar várias Situações"
            >
                Situação
            </label>
            <select
                multiple
                id="ConsultaOrdemDeProducao_ListaSituacoesPedido"
                className={clsx(estilosInputs.select, "_h-auto")}
                title="Use as teclas SHIFT ou CTRL para selecionar várias Situações"
                size={props.filtro?.Situacoes?.length ?? 0}
                disabled={props.processando}
                onChange={(e) => {
                    const situacoesSelecionadas = Array.from(e.target.selectedOptions).map((o) => o.value)
                    formik.setFieldValue("ListaSituacoesPedido", situacoesSelecionadas)
                }}
            >
                {props.filtro?.Situacoes?.map((d) => (
                    <option
                        key={d.Codigo}
                        value={d.Codigo}
                    >
                        {d.Descricao}
                    </option>
                ))}
            </select>
        </>
    ), [props.filtro?.Situacoes, props.processando])

    const handleVendedorInputChange = useCallback((event: React.SyntheticEvent, value: string, reason: string) => {
        if (event && (event.type === 'blur' || reason === 'clear' || reason === 'reset')) {
            const lista = formik.values.Vendedores?.filter((vendedor) =>
                formik.values.ListaVendedoresSelecionados?.indexOf(vendedor.CodigoVendedor) <= -1
            )
            setListaVendedoresFiltrados(lista || [])
            setInputValueVendedor('')
        } else if (event && reason === 'input') {
            const valor = value.includes("%") ? value.replace(/%/g, "") : value
            setInputValueVendedor(valor)

            const lista = props.filtro?.Vendedores?.filter((vendedor) =>
                vendedor?.Nome?.toLowerCase().includes(valor.toLowerCase()) ||
                vendedor?.CodigoVendedor?.toLowerCase().startsWith(valor.toLowerCase())
            )?.filter((vendedor) => formik.values.ListaVendedoresSelecionados?.indexOf(vendedor.CodigoVendedor) <= -1)

            setListaVendedoresFiltrados(lista || [])
        }
    }, [formik.values, props.filtro?.Vendedores])

    const handleVendedorChange = useCallback((_e: React.SyntheticEvent, vendedores: Vendedor[]) => {
        const listaCodVen = vendedores?.map((vendedor) => vendedor.CodigoVendedor) || []
        formik.setFieldValue("ListaVendedoresSelecionados", listaCodVen)

        const lista = listaVendedoresFiltrados?.filter((vendedor) =>
            listaCodVen.indexOf(vendedor.CodigoVendedor) <= -1
        ) || []

        setListaVendedoresFiltrados(lista)
    }, [listaVendedoresFiltrados])

    const handleFilialInputChange = useCallback((event: React.SyntheticEvent, value: string, reason: string) => {
        if (event && (event.type === 'blur' || reason === 'clear' || reason === 'reset')) {
            const lista = formik.values.Filiais?.filter((filial) =>
                formik.values.ListaFiliaisSelecionadas?.indexOf(filial.Codigo) <= -1
            )
            setListaFiliaisFiltradas(lista || [])
            setInputValueFilial('')
        } else if (event && reason === 'input') {
            const valor = value.includes("%") ? value.replace(/%/g, "") : value
            setInputValueFilial(valor)

            const lista = props.filtro?.Filiais?.filter((filial) =>
                filial?.Nome?.toLowerCase().includes(valor.toLowerCase()) ||
                filial?.Codigo?.toLowerCase().startsWith(valor.toLowerCase())
            )?.filter((filial) => formik.values.ListaFiliaisSelecionadas?.indexOf(filial.Codigo) <= -1)

            setListaFiliaisFiltradas(lista || [])
        }
    }, [formik.values, props.filtro?.Filiais])

    const handleFilialChange = useCallback((_e: React.SyntheticEvent, filiais: IFilial[]) => {
        const listaFiliais = filiais?.map((filial) => filial.Codigo) || []
        formik.setFieldValue("ListaFiliaisSelecionadas", listaFiliais)

        const lista = listaFiliaisFiltradas?.filter((filial) =>
            listaFiliais.indexOf(filial.Codigo) <= -1
        ) || []

        setListaFiliaisFiltradas(lista)
    }, [listaFiliaisFiltradas])

    const filtroVendedores = useMemo(() => {
        if (!props.filtro?.Vendedores?.length) return null;

        return (
            <div className={`${estilosInputs.gridAutocomplete} "_flex _my-2"`}>
                <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">
                    Vendedor
                </label>

                <div className={`${estilosInputs.autocomplete} "_h-auto"`}>
                    {props.filtro.Vendedores.length <= 1 ? (
                        <select
                            id="ConsultaOrdemDeProducao_ListaVendedor"
                            className={clsx("_w-[200px]", estilosInputs.inputPadrao)}
                            disabled={true}
                        >
                            {props.filtro.Vendedores.map((d) => (
                                <option key={d.CodigoVendedor} value={d.CodigoVendedor}>
                                    {d.Nome}
                                </option>
                            ))}
                        </select>
                    ) : (
                        <Autocomplete
                            style={{ minWidth: '400px' }}
                            noOptionsText={"Digite..."}
                            multiple
                            id="ConsultaOrdemDeProducao_filtroVendedores"
                            options={listaVendedoresFiltrados}
                            value={props.filtro.Vendedores.filter((vendedor) =>
                                formik.values.ListaVendedoresSelecionados?.includes(vendedor.CodigoVendedor)
                            )}
                            getOptionLabel={(vendedor) => `${vendedor.CodigoVendedor}-${vendedor.Nome}`}
                            inputValue={inputValueVendedor}
                            disabled={props.processando}
                            onInputChange={handleVendedorInputChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Digite..."
                                    title="Digite o nome ou código do Vendedor"
                                />
                            )}
                            onChange={handleVendedorChange}
                            disablePortal={true}
                        />
                    )}
                </div>
            </div>
        )
    }, [
        props.filtro?.Vendedores,
        props.processando,
        listaVendedoresFiltrados,
        inputValueVendedor,
        formik.values.ListaVendedoresSelecionados,
        handleVendedorInputChange,
        handleVendedorChange
    ])

    const filtroFiliais = useMemo(() => {
        if (!props.filtro?.Filiais?.length) return null;

        return (
            <div className={`${estilosInputs.gridAutocomplete} "_flex _my-2"`}>
                <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">
                    Filial
                </label>

                {props.filtro.Filiais.length <= 1 ? (
                    <select
                        id="ConsultaOrdemDeProducao_ListaFiliais"
                        className={clsx("_w-[200px]", estilosInputs.inputPadrao)}
                        disabled={true}
                    >
                        {props.filtro.Filiais.map((d) => (
                            <option key={d.Oid} value={d.Oid}>
                                {d.Nome}
                            </option>
                        ))}
                    </select>
                ) : (
                    <div className={`${estilosInputs.autocomplete} "_h-auto _w-[400px]"`}>
                        <Autocomplete
                            style={{ minWidth: '400px' }}
                            noOptionsText={"Digite..."}
                            multiple
                            id="ConsultaOrdemDeProducao_filtroFiliais"
                            options={listaFiliaisFiltradas}
                            value={props.filtro.Filiais.filter((filial) =>
                                formik.values.ListaFiliaisSelecionadas?.includes(filial.Codigo)
                            )}
                            getOptionLabel={(filial) => `${filial.Codigo}-${filial.Nome}`}
                            inputValue={inputValueFilial}
                            disabled={props.processando || props.filtro.Filiais.length === 1}
                            onInputChange={handleFilialInputChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Digite..."
                                    title="Digite o nome ou código da filial"
                                />
                            )}
                            onChange={handleFilialChange}
                            disablePortal={true}
                        />
                    </div>
                )}
            </div>
        )
    }, [
        props.filtro?.Filiais,
        props.processando,
        listaFiliaisFiltradas,
        inputValueFilial,
        formik.values.ListaFiliaisSelecionadas,
        handleFilialInputChange,
        handleFilialChange
    ])

    const headerTabela = useMemo(() => {
        const mapHeader = ["Filial", "Data", "Orçamento", "Vendedor", "Cliente", "Produto", "Descrição", "Reservou Estoque", "Situação Orçamento", "Ordem de Produção"]

        return mapHeader.map((nome, index) => (
            <th
                key={`header-${nome}-${index}`}
                className="_table-cell"
                style={{ position: 'relative', textAlign: 'center', paddingRight: '30px' }}
            >
                {nome}
                <FontAwesomeIcon
                    className={estilosBotoes.iconOrdenacao}
                    title="Pesquisa novamente alterando a ordenação pela coluna"
                    style={props.colunaOrdenacao === nome
                        ? { color: '#008000', fontWeight: 'bolder', opacity: 2, position: 'absolute', cursor: props.processando ? 'not-allowed' : 'pointer' }
                        : { position: 'absolute', cursor: props.processando ? 'not-allowed' : 'pointer' }
                    }
                    icon={props.colunaOrdenacao !== nome || (props.colunaOrdenacao === nome && !props.ordemOrdenacaoDecrescente)
                        ? faChevronDown
                        : faChevronUp
                    }
                    onClick={() => {
                        if (props.processando) return;
                        props.onAlterarOrdenacaoDados?.(
                            nome,
                            props.colunaOrdenacao === nome ? !props.ordemOrdenacaoDecrescente : false,
                            props.filtro
                        )
                    }}
                />
            </th>
        ))
    }, [props.colunaOrdenacao, props.ordemOrdenacaoDecrescente, props.processando, props.onAlterarOrdenacaoDados, props.filtro])

    const handleNumeroPedidoChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        let numeroPedido = 0;
        const numericValue = event.target.value.replace(/\D/g, '');
        if (numericValue.length > 0) {
            numeroPedido = parseInt(numericValue, 10);
        }
        formik.handleChange({ target: { name: 'NumeroPedido', value: numeroPedido } });
        props.onNumeroPedidoAlterado?.(numeroPedido);
    }, [props.onNumeroPedidoAlterado])

    const bodyTabela = useCallback((dado: DadosOrdemDeProducao) => {
        const mapHeader = {
            'Filial': dado.FilialPedido,
            'Data': globalMU.formatDate(dado.DataPedido),
            'Orçamento': dado.NumeroPedido,
            'Vendedor': dado.Vendedor,
            'Cliente': dado.NomeCliente,
            'Produto': dado.CodigoProdutoMostrar,
            'Descrição': dado.DescricaoProduto,
            'Reservou Estoque': dado.EstoqueReservado,
            'Situação Orçamento': dado.SituacaoPedido,
            'Ordem de Produção': dado.CodigoOrdemProducao
        }

        return Object.entries(mapHeader).map(([campo, valor], index) => (
            <td
                key={index}
                style={index === 0
                    ? {
                        boxShadow: dado.CorLegenda && dado.CorLegenda !== "" ? `inset 4px 0px ${dado.CorLegenda}` : undefined,
                        textAlign: 'center',
                        cursor: props.processando ? 'not-allowed' : 'pointer'
                    }
                    : campo === "Produto"
                        ? {
                            boxShadow: dado.ExiteInsumoSemEstoque === 1 ? `inset 4px 0px #AB2DE1` : undefined,
                            borderRight: dado.Nivel === 1 ? `1px solid black` : dado.Nivel > 1 ? `${(dado.Nivel - 1) * 2}px solid black` : undefined,
                            cursor: props.processando ? 'not-allowed' : 'pointer'
                        }
                        : campo === 'Reservou Estoque'
                            ? { textAlign: 'center', cursor: props.processando ? 'not-allowed' : 'pointer' }
                            : { cursor: props.processando ? 'not-allowed' : 'pointer' }
                }
                title={dado.CodigoProdutoPaiMostrar && dado.CodigoProdutoPaiMostrar !== "" ?
                    `Produto Pai: ${dado.CodigoProdutoPaiMostrar}`
                    : undefined
                }
                id={`ConsultaOrdemDeProducao_Tabela_Body_Row_Cell_${index}_${campo}`}
                className={`_table-cell`}
            >
                {campo === 'Reservou Estoque' ? (
                    (dado.ProdutoComponente === 0 ?
                        <input
                            type="checkbox"
                            style={{ textAlign: 'center' }}
                            checked={dado.EstoqueReservado === 'S'}
                            disabled
                        />
                        : undefined)
                ) : valor}
            </td>
        ))
    }, [props.processando])

    const handleSubmit = useCallback((e: React.FormEvent) => {
        e.preventDefault();
        formik.handleSubmit();
    }, [formik])

    useEffect(() => {
        
        if (props.cancelamentoMultiplo) {
            
            window.scrollTo({
                top: document.body.scrollHeight,
                behavior: 'smooth', // Efeito suave (opcional)
            })

            botaoConfirmacaoCancelarMultiploRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' })
        }
    }, [props.cancelamentoMultiplo])

    useEffect(() => {
        if (props.pedirSenhaLiberacao) {

            senhaLiberacaoRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' })
        }
    }, [props.pedirSenhaLiberacao])

    useEffect(() => {
        if (props.listaOrdemProducao?.Entities?.length > 0) {

            posicaoParaScrollTabelaRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' })// 472375
        }
    }, [props.listaOrdemProducao?.Entities?.length])

    return (
        <>
            <form
                id="ConsultaOrdemDeProducao_FormularioFiltroPesquisa"
                onSubmit={handleSubmit}
            >
                <div className="_mt-4 _mb-8">
                    <div className="_flex _my-2">
                        <label
                            className="_text-right _w-[160px] _font-normal _mb-0 _mr-3"
                        >Nº Orçamento</label>
                        <input
                            disabled={props.processando}
                            type="text"
                            name="NumeroPedido"
                            id="ConsultaOrdemDeProducao_CampoFiltro_NumeroPedido"
                            autoFocus
                            className={clsx("_w-[200px]", estilosInputs.inputPadrao)}
                            value={formik.values.NumeroPedido > 0 ? formik.values.NumeroPedido : ""}
                            onChange={handleNumeroPedidoChange}
                        />
                    </div>
                    {filtroVendedores}
                    {filtroFiliais}

                    <div className="_flex _my-2">
                        <label
                            className="_text-right _w-[160px] _font-normal _mb-0 _mr-3"
                        >Data Inicial
                        </label>
                        <InputData
                            disabled={props.processando}
                            id="ConsultaOrdemDeProducao_CampoFiltro_DataInicial"
                            className={`_w-[200px] ${estilosInputs.inputPadrao} ${formularioValidado && formik.errors.DataInicial != undefined && estilosInputs.inputComErro}`}
                            data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(formik.values.DataInicial)}
                            onChange={(e) => formik.setFieldValue("DataInicial", e)}
                            selecionaValorOnFocus
                        />
                    </div>
                    <div className="_flex _my-2">
                        <label
                            className="_text-right _w-[160px] _font-normal _mb-0 _mr-3"
                        >
                            Data Final</label>
                        <InputData
                            disabled={props.processando}
                            id="ConsultaOrdemDeProducao_CampoFiltro_DataFinal"
                            className={clsx("_w-[200px]", estilosInputs.inputPadrao)}
                            data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(formik.values.DataFinal)}
                            onChange={(e) => formik.setFieldValue("DataFinal", e)}
                            selecionaValorOnFocus
                        />
                    </div>
                    <div className="_flex _my-2">
                        {listBoxSituacoes}
                    </div>
                    <div className="_flex _my-2">
                        {comboBoxEstoqueReservado}
                    </div>
                    <div className="_flex _my-2">
                        {inputFiltroProdutos}
                    </div>
                    {props.produtosFiltrados?.length > 0 && produtosFiltradosTable}
                </div>

                <div className="_flex _my-3 _justify-start _items-start _flex-wrap">

                    <button
                        //className={`_flex _my-2 no-global-button ${estilosBotoes.botaoPrimario}`}
                        className={`_flex _mr-2 no-global-button ${estilosBotoes.botaoPrimario}`}
                        type="submit"
                        id="ConsultaOrdemDeProducao_BotaoPesquisarOP"
                        title="Veja parâmetros: &#0013;- Utiliza controle de produção?&#0013;- PCP - Gerar ordem de produção para insumos que são produtos de fabricação própria?&#0013;- PCP – Permitir desdobrar e trocar local de retirada de pedidos com ordens de produção"
                        disabled={props.processando && !props.pedirSenhaLiberacao && !props.cancelamentoMultiplo}
                    >
                        {props.processando && !props.pedirSenhaLiberacao && !props.cancelamentoMultiplo ? "Aguarde..." : "Pesquisar"}
                    </button>
                </div>
            </form>
            {botaoSelecionarTodos}
            <div className="_flex _my-3 _justify-start _items-start _flex-wrap">
                {botaoOrdemProducao}
                {botaoEditarOrdemProducao}
                {botaoCancelarOrdemProducao}
            </div>

            {props.listaOrdemProducao?.Entities?.length > 0 && <>
                <div className={estiloTabela.containerRolavel}>
                    <table className={`_table _w-full ${estiloTabela.tabela}`}
                        id="ConsultaOrdemDeProducao_Tabela"
                    >
                        <thead className="_table-header-group"
                            id="ConsultaOrdemDeProducao_Tabela_Header"
                        >
                            <tr className="_table-row"
                                id="ConsultaOrdemDeProducao_Tabela_Header_Row"
                            >
                                {headerTabela}
                            </tr>
                        </thead>
                        <tbody className="_table-row-group"
                            id="ConsultaOrdemDeProducao_Tabela_Body"
                        >
                            {props.listaOrdemProducao?.Entities?.map((dado, index) => (
                                <tr
                                    key={index}
                                    className={`_table-row ${!props.processando && estiloTabela.linhaClicavel}
                                                         ${props.ordemProducaoSelecionadoLista
                                        && props.ordemProducaoSelecionadoLista?.find((produtoOP) => produtoOP.Index == dado.Index)
                                        && estiloTabela.linhaSelecionada}`
                                    }
                                    onClick={() => props.toggleOrdemProducaoSelecionado(dado)}
                                    style={{ cursor: props.processando ? 'not-allowed' : 'pointer' }}
                                >
                                    {bodyTabela(dado)}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {props.listaOrdemProducao?.Entities?.length > 0 && props.listaOrdemProducao?.PageCount > 1
                    && (
                        <div className="_my-2">
                            <Paginacao
                                paginaAtual={props.listaOrdemProducao.ActualPage}
                                totalPaginas={props.listaOrdemProducao.PageCount}
                                desabilitarPaginacao={props.processando}
                                id="ConsultaOrdemDeProducao_Paginacao"
                                onAlterarListaSelecionada={(pagina) => props.onPesquisar(pagina, { ...formik.values }, false)}
                            />
                        </div>
                    )}
                {props.ordemProducaoSelecionadoLista && props.ordemProducaoSelecionadoLista.length > 0 && ( // 472375
                    <span 
                        className="_text-sm _mb-2"
                        style={{cursor:'default'}}
                    >Selecionado(s): {props.ordemProducaoSelecionadoLista?.length ?? 0}</span>
                )}
                {props.listaOrdemProducao?.Entities?.length > 5 // so repetir os botoes se tiver muitos registros
                    && (
                        <div className="_flex _my-3 _justify-start _items-start _flex-wrap">
                            {botaoOrdemProducao}
                            {botaoEditarOrdemProducao}
                            {botaoCancelarOrdemProducao}
                        </div>
                    )}


                {props.pedirSenhaLiberacao && (
                    <div className="_my-4 _bg-[#e4e6e8] _p-4"
                        ref={senhaLiberacaoRef}
                    >

                        <SolicitarSenhaContainer // 457575
                            onRemover={() => { }}
                            onVoltar={() => { }}
                            passos={null}
                            exibirBotaoVoltar={false}
                            onSenhaValidada={props.onSenhaValidada}
                            dicaPermissao="Permissão: [Libera ordem de produção sem quantidade disponível]"
                            permissao={"TIPO_LIBERACAO_LIBERA_OP_SEM_QUANT_DISPONIVEL"}
                            textoAdicional={"Existe insumo sem estoque disponível"}
                        />
                    </div>
                )}

                {props.cancelamentoMultiplo && (
                    <div className={clsx(estiloFormulario.formulario, "_max-w-md")}>
                        <button
                            id="ConsultaOrdemDeProducao_ConfirmacaoCancelamentoMultiplo"
                            className={`_flex _mr-2 no-global-button ${estilosBotoes.botaoPrimario}`}
                            onClick={props.onConfirmarCancelamentoMultiplo} // 472375
                            ref={botaoConfirmacaoCancelarMultiploRef}
                            //disabled={props.processando}
                        >
                            Confirma Cancelamento dos Registros Selecionados?
                        </button>
                    </div>
                )}

                <div className="_my-4">
                    <Legenda itens={[{
                        nome: "Item Indisponível para Ordem de Produção",
                        cor: "#FF0000",
                    },
                    {
                        nome: "Estoque Disponível",
                        cor: "#00FF00",
                    },
                    {
                        nome: "Existe Insumo Sem Estoque Disponível",
                        cor: "#AB2DE1",
                    }

                    ]} />
                </div>
            </>}
            <section style={{ marginBottom: "100px" }} />
        </>
    )
}